// @flow
import * as React from 'react';
import styled from 'styled-components';
import colors from '../../assets/css/colors';
import { CountdownTimer } from '../';
import { below } from '../../assets/css/media';

const CountdownLabel = styled.p`
	font-size: 10px;
	letter-spacing: 0.5px;
	line-height: 1.4;
	text-align: center;
	color: ${colors.nrlDarkGreenHover};
	text-transform: uppercase;
`;
const CountdownWrapper = styled.div`
	text-align: center;
	margin-left: auto;
	margin-right: 1em;
	> div {
		margin-top: 6px;
	}
	${below.desktop`
		display: none;
	`}
`;

type Props = {
	league: Object,
	selected_round: Object
};

export const GameBarTimer = ({ league, selected_round }: Props) => {
	const { status, start_at } = league,
		{ id, start } = selected_round;

	if (status === 'scheduled') {
		return (
			<CountdownWrapper>
				<CountdownLabel>
					League Starts in
				</CountdownLabel>
				<CountdownTimer is_uppercase date={start_at} label_type="short" />
			</CountdownWrapper>
		);
	}

	if (selected_round.status === 'active') {
		return (
			<CountdownWrapper>
				<CountdownLabel>Round {id} in Progress</CountdownLabel>
			</CountdownWrapper>
		);
	}

	if (selected_round.status === 'complete') {
		return (
			<CountdownWrapper>
				<CountdownLabel>Round {id} Complete</CountdownLabel>
			</CountdownWrapper>
		);
	}

	return (
		<CountdownWrapper>
			<CountdownLabel>Round {id} Lockout</CountdownLabel>
			<CountdownTimer is_uppercase date={start} label_type="short" />
		</CountdownWrapper>
	);
};

export default GameBarTimer;


// WEBPACK FOOTER //
// ./src/components/League/GameBarTimer.js